/**
 * Text display GUI component
 */

import { Text, Box } from "@mantine/core";
import type { GuiTextElement } from "../types";

interface GuiTextProps {
  element: GuiTextElement;
}

export function GuiText({ element }: GuiTextProps) {
  return (
    <Box style={{ marginBottom: "8px" }}>
      <Text size="sm">{element.content}</Text>
    </Box>
  );
}
